var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.4375 1.40625C4.81445 1.40625 4.25586 1.75 3.93359 2.26562C3.63281 2.80273 3.63281 3.46875 3.93359 3.98438C4.25586 4.52148 4.81445 4.84375 5.4375 4.84375C6.03906 4.84375 6.59766 4.52148 6.91992 3.98438C7.2207 3.46875 7.2207 2.80273 6.91992 2.26562C6.59766 1.75 6.03906 1.40625 5.4375 1.40625ZM5.4375 5.875C4.44922 5.875 3.54688 5.35938 3.05273 4.5C2.55859 3.66211 2.55859 2.60938 3.05273 1.75C3.54688 0.912109 4.44922 0.375 5.4375 0.375C6.4043 0.375 7.30664 0.912109 7.80078 1.75C8.29492 2.60938 8.29492 3.66211 7.80078 4.5C7.30664 5.35938 6.4043 5.875 5.4375 5.875ZM2.75195 7.9375L2.02148 10.3438H8.85352L8.10156 7.9375H2.75195ZM8.875 6.90625L9.92773 10.3438L10.25 11.375H9.1543H1.69922H0.625L0.925781 10.3438L2 6.90625H8.875ZM10.7656 4.67188H13.8594H14.375V5.70312H13.8594H10.7656H10.25V4.67188H10.7656Z",
    fill: "#9DD2FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDelete);
export default __webpack_public_path__ + "static/media/user-delete.ef932da3c0897eaf456186625e42ddae.svg";
export { ForwardRef as ReactComponent };